import React, { createContext, useContext, useState, useCallback } from 'react';
import { getClientTimezone } from '../utils/timezone';

const STORAGE_KEY = 'kg_timezone';

interface TimezoneContextValue {
  timezone: string;
  setTimezone: (tz: string) => void;
}

const TimezoneContext = createContext<TimezoneContextValue | null>(null);

export function TimezoneProvider({ children }: { children: React.ReactNode }) {
  const [timezone, setTimezoneState] = useState<string>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) ?? getClientTimezone();
    } catch {
      return getClientTimezone();
    }
  });

  const setTimezone = useCallback((tz: string) => {
    setTimezoneState(tz);
    try { localStorage.setItem(STORAGE_KEY, tz); } catch {}
  }, []);

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
}

export function useTimezone(): TimezoneContextValue {
  const ctx = useContext(TimezoneContext);
  if (!ctx) throw new Error('useTimezone must be used inside <TimezoneProvider>');
  return ctx;
}
